<template>
  <div id="request-quote" class="tw-w-full tw-px-4 md:tw-px-0 md:tw-w-8/12 tw-mt-12 tw-mb-6">
    <div class="tw-w-full tw-flex tw-justify-between tw-px-0 md:tw-px-12">
      <div id="private" class="tw-w-20 md:tw-w-32 tw-h-20 md:tw-h-32 tw-cursor-pointer tw-border tw-border-gray-300 tw-flex tw-items-center tw-justify-center tw-flex-col tw-rounded-full" @click="insuranceType=70">
        <v-icon :color="insuranceType === 70 ? 'primary1': 'primary'" size="80">mdi-car-outline</v-icon>
        <span :class="insuranceType === 70 ? 'c-blue-text': 'c-navy-text'">Private</span>
      </div>
      <!-- <div id="commercial" class="tw-w-20 md:tw-w-32 tw-h-20 md:tw-h-32 tw-cursor-pointer tw-border tw-border-gray-300 tw-flex tw-items-center tw-justify-center tw-flex-col tw-rounded-full" @click="insuranceType='commercial'">
        <v-icon :color="insuranceType === 'commercial' ? 'primary1': 'primary'" size="80">mdi-truck</v-icon>
        <span :class="insuranceType === 'commercial' ? 'c-blue-text': 'c-navy-text'">Commercial</span>
      </div>
      <div id="moto" class="tw-w-20 md:tw-w-32 tw-h-20 md:tw-h-32 tw-cursor-pointer tw-border tw-border-gray-300 tw-flex tw-items-center tw-justify-center tw-flex-col tw-rounded-full" @click="insuranceType='moto'">
        <v-icon :color="insuranceType === 'moto' ? 'primary1': 'primary'" size="80">mdi-motorbike</v-icon>
        <span :class="insuranceType === 'moto' ? 'c-blue-text': 'c-navy-text'">Motorcycle</span>
      </div> -->
    </div>

    <transition name="fade" mode="out-in">
      <div v-if="insuranceType === 70" class="tw-w-full tw-mt-8 md:tw-mt-12">
        <h3 class="tw-text-1xl md:tw-text-2xl c-gray-text tw-pb-3">Vehicle Details</h3>
        <hr>

        <v-form v-model="isValid" class="tw-mt-5 tw-w-full">
          <div class="tw-w-full tw-flex tw-flex-wrap md:tw-flex-no-wrap">
            <v-autocomplete
                id="carMakes"
                v-model="carMake"
                :loading="carLoading"
                :items="carMakeItems"
                :search-input.sync="carMakeSearch"
                class="tw-w-full md:tw-w-1/2 tw-mt-6 md:tw-mt-0 mx-4"
                hide-no-data
                hide-details
                label="Vehicle Make"
                :rules="[required('Vehicle Make')]"
            ></v-autocomplete>

            <v-autocomplete
                id="carModels"
                v-model="carModel"
                :loading="modelLoading"
                :items="carModelItems"
                :search-input.sync="carModelSearch"
                class="tw-w-full md:tw-w-1/2 tw-mt-6 md:tw-mt-0 mx-4"
                hide-no-data
                hide-details
                label="Vehicle Model"
                :rules="[required('Vehicle Model')]"
            ></v-autocomplete>
          </div>
          <div class="tw-w-full tw-flex tw-mt-2 md:tw-mt-16 tw-flex-wrap md:tw-flex-no-wrap">
            <v-autocomplete
                id="year"
                v-model="year"
                type="number"
                :items="yearList"
                :search-input.sync="yearSearch"
                cache-items
                class="tw-w-full md:tw-w-1/2 tw-mt-6 md:tw-mt-0 mx-4"
                hide-no-data
                hide-details
                label="Year of Manufacture"
                :rules="[required('Year of Manufacture')]"
            ></v-autocomplete>
            <div class="tw-w-full md:tw-w-1/2 tw-mt-6 md:tw-mt-0">
              <vuetify-money
                  id="amount"
                  v-model="carAmount"
                  label="Value of Vehicle"
                  type="text"
                  name="amount"
                  class="mx-4"
                  :rules="[required('Value of Vehicle'), minAmount('Value of Vehicle', 0)]"
                  :options="options"
              ></vuetify-money>
<!--              <small class="c-yellow-text tw-italic"> <v-icon size="14" color="secondary">mdi-information-outline</v-icon> Minimum value for Comprehensive cover is KES 600,000</small>-->
            </div>
          </div>
          <v-card-actions class="col-sm-6 tw-mt-5 offset-sm-3">
            <v-btn block large
                   id="submit"
                   color="secondary"
                   class="my-3 "
                   :loading="loading"
                   :disabled="!isValid && !cantRFQ"
                   @click="requestMotor"
            >
              Get Quote
            </v-btn>
          </v-card-actions>
        </v-form>
      </div>
      <div v-else class="tw-flex tw-items-center tw-justify-center tw-mt-8 md:tw-mt-12">
        <div class="tw-w-full md:tw-w-7/12 tw-text-center">
          <p>We currently do not offer {{ insuranceType === 'moto' ? 'Motorcycle' : 'Motor Commercial' }} insurance online. For a quote and more details please call our customer experience team on <strong>0730677000</strong>.
            <br> Alternatively, you can provide your Name and Mobile number below and our team will contact you.</p>

          <submit-contact :insurance-type="insuranceType" @contact-form-submitted="closeModal" />
        </div>
      </div>
    </transition>
    <no-rfq-modal :model="unsupportedModel" />
  </div>
</template>

<script>
/* eslint-disable no-param-reassign,no-plusplus */

import SubmitContact from '@/components/rfq/SubmitContact';
import axios from 'axios';
import validations from '@/utils/validations';
import helpers from '@/utils/helpers';
import { mapGetters } from 'vuex';
import NoRfqModal from '@/components/rfq/NoRfqModal';
import { FB_RFQ_START } from '@/utils/const';

export default {
  name: 'RequestQuote',
  components: { NoRfqModal, SubmitContact },
  data() {
    return {
      loading: false,
      carMakes: [],
      carMake: null,
      carMakeObj: {},
      carMakeSearch: null,
      carMakeItems: [],
      carLoading: false,
      carModels: [],
      carModel: null,
      carModelObj: {},
      carModelSearch: null,
      carModelItems: [],
      modelLoading: false,
      yearList: this.years(2000),
      year: null,
      carAmount: '',
      yearSearch: null,
      insuranceType: 70,
      ...validations,
      ...helpers,
      options: {
        locale: 'en',
        prefix: 'Kes',
        suffix: '',
        // length: 9,
        precision: 0,
      },
      isValid: false,
      cantRFQ: false,
      unsupportedModel: null,
    };
  },
  computed: {
    ...mapGetters('auth', ['authenticatedUser', 'isAuthenticated']),
  },
  mounted() {
    this.getCarMakes();
  },
  watch: {
    carModelSearch(val) {
      // eslint-disable-next-line no-unused-expressions
      val && val !== this.carModel && this.carModelFilter(val);

      this.carModelObj = this.carModels.find((x) => x.modelname === this.carModel);
      if (this.carModelObj !== undefined) {
        if (this.carModelObj.quoteExcluded === 'Y') {
          this.cantRFQ = true;
          this.$root.$emit('open-modal-rfq');
          this.carModelObj = {};
          this.unsupportedModel = this.carModel;
          this.carModel = null;
        } else {
          this.cantRFQ = false;
        }
      }
    },
    async carMakeSearch(val) {
      // eslint-disable-next-line no-unused-expressions
      val && val !== this.carMake && this.carMakeFilter(val);

      this.carMakeObj = await this.carMakes.find((x) => x.makeDetails === this.carMake);
      this.carModel = null;
      if (!helpers.objIsEmpty(this.carMakeObj)) this.getCarModels(this.carMakeObj.vmkcode);
    },
  },
  methods: {
    async requestMotor() {
      this.loading = true;
      // await this.getProductGroupItems().then((res) => {
      await this.getProductGroupItems().then(() => {
        // const standardMotor = res.find((x) => x.productCode === 700);
        // const standardMotor = res.find((x) => x.productCode === 3437);
        const data = {
          origin: 'P',
          agentId: 0,
          carDTOS: [
            {
              carId: 0,
              coverTypeId: 0,
              evaluationSelected: -1,
              hasInsurance: false,
              make: this.carMake,
              model: this.carModel,
              riskId: 0,
              seatingCapacity: 0,
              valueOfCar: parseInt(this.carAmount, 10),
              valueOfEntertainmentScreen: 0,
              valueOfWindScreen: 0,
              vehicleImages: [],
              yearOfManufacture: this.year,
            },
          ],
          // prodId: standardMotor.productCode,
          prodId: 3437,
          email: this.isAuthenticated ? this.authenticatedUser.email : '',
          fullName: this.isAuthenticated ? this.authenticatedUser.name : '',
          kraPinNumber: this.isAuthenticated ? this.authenticatedUser['custom:kra-pin'] : '',
        };
        this.$analytics.logEvent(FB_RFQ_START, data);
        axios.post('/customer/quotation/create', data).then((response) => {
          this.loading = false;
          // this.$emit('request-submitted', { quote: response.data.data, prodId: standardMotor.productCode, bimaId: 702 });
          // this.$emit('request-submitted', { quote: response.data.data, prodId: 70 });
          this.$emit('request-submitted', { quote: response.data.data, prodId: 3437 });
        });
      });
    },
    getProductGroupItems() {
      return axios.get(`/customer/gis/products/productgroup/${this.insuranceType}/retrieveall`).then((response) => response.data.object);
    },
    getCarMakes() {
      this.carLoading = true;
      axios.get('/customer/gis/vehicles/make/retrieveAll').then((response) => {
        this.carLoading = false;
        this.carMakes = response.data.object;
      });
    },
    async getCarModels(id) {
      this.modelLoading = true;
      await axios.get(`/customer/gis/vehicles/${id}/models`).then((response) => {
        this.modelLoading = false;
        this.carModels = response.data.object;
      });
    },
    carMakeFilter(v) {
      const makes = [];
      this.carMakes.forEach((make) => {
        makes.push(make.makeDetails);
      });
      setTimeout(() => {
        this.carMakeItems = makes.filter((e) => (e || '').toUpperCase().indexOf((v || '').toUpperCase()) > -1);
      }, 500);
    },
    carModelFilter(v) {
      const models = [];
      this.carModels.forEach((make) => {
        models.push(make.modelname);
      });
      setTimeout(() => {
        this.carModelItems = models.filter((e) => (e || '').toUpperCase().indexOf((v || '').toUpperCase()) > -1);
      }, 500);
    },
    years(startYear) {
      const currentYear = new Date().getFullYear();
      const years = [];
      startYear = startYear || 2000;
      // startYear = currentYear - 12;
      while (startYear <= currentYear) {
        const newYear = startYear++;
        years.push(newYear.toString());
      }
      return years.reverse();
    },
    closeModal() {
      this.insuranceType = 70;
    },
  },
};
</script>
